// StarRatingSmall.js
/* import React from 'react';

const StarRatingSmall = ({ rating, setRating, readonly, className }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span
        key={i}
        className={`star ${className} ${i <= rating ? 'filled' : ''}`}
        onClick={() => !readonly && setRating(i)}
      >
        ★
      </span>
    );
  }

  return <div>{stars}</div>;
};

export default StarRatingSmall; */

import React, { useState } from 'react';

const StarRatingSmall = ({ rating, setRating }) => {
  const [hover, setHover] = useState(0);

  return (
    <div className="star-rating-small">
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className={index <= (hover || rating) ? "on" : "off"}
            onClick={() => setRating(index)}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(rating)}
          >
            <span className="star">&#9733;</span>
          </button>
        );
      })}
    </div>
  );
};

export default StarRatingSmall;
